<template>
  <v-card style="height: 120%" class="rounded-lg">
    <v-card-title
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 33px;
        font-weight: bold;
        color: #05523e;
        padding-top: 40px;
      "
    >
      Select Product
    </v-card-title>
    <v-icon class="close" size="35" @click="closeModal"
      >mdi-window-close</v-icon
    >

    <!-- search -->
    <div
      style="
        margin: 1.5% 3.5% auto;
        justify-content: center;
        align-items: center;
      "
    >
      <!-- search by word -->
      <div style="display: flex; height: 40px; align-items: self-end">
        <div style="font-size: 23px; font-weight: bold; width: 150px">
          Category
        </div>
        <v-select
          v-model="categoryColumn"
          label="All"
          :items="categories"
          item-text="name"
          item-value="value"
          style="max-width: 160px; min-width: 100px; height: 46px"
          single-line
          color="#05523E"
        />
        <v-text-field
          v-model="search"
          style="
            margin: -20px 10px -20px 20px;
            max-width: 150px;
            min-width: 100px;
          "
          placeholder="Search"
          clearable
          v-on:keyup.enter="searchByWord"
        />
        <v-btn
          class="white--text elevation-5 rounded-lg"
          color="#05523E"
          style="max-width: 130px; min-width: 110px; height: 32px"
          @click="searchByWord"
          >Search</v-btn
        >
      </div>
      <!-- search by department -->
      <div style="display: flex">
        <div
          style="
            font-size: 23px;
            font-weight: bold;
            width: 150px;
            line-height: 65px;
          "
        >
          Department
        </div>
        <v-select
          v-model="departmentColumn"
          label="All"
          @input="searchByDepartment"
          :items="$store.state.invoice.departments"
          item-text="name"
          item-value="value"
          style="max-width: 160px; min-width: 100px"
          single-line
          color="#05523E"
        />
      </div>
    </div>
    <div style="margin: 0.5% 3.5% auto; padding-bottom: 20px">
      <v-data-table
        :headers="headers"
        :items="$store.state.invoice.inventoryList"
        :page.sync="page_No"
        :items-per-page="10"
        hide-default-footer
        class="elevation-3"
      >
        <!-- <template v-slot:header="{ props: { headers } }">
                    <thead>
                        <tr>
                            <th v-for="h in headers" v-bind:key="h.text">
                                <span style="color: black; font-weight: bold; font-size: 17px;">{{h.text}}</span>
                            </th>
                        </tr>
                    </thead>
                </template> -->
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.itemNum }}</td>
            <td>{{ item.itemName }}</td>
            <td>{{ item.vendorName }}</td>
            <td>{{ item.department }}</td>
            <td>
              <v-btn
                class="elevation-3"
                style="
                  width: 12px;
                  margin: 0;
                  color: white;
                  background-color: #05523e;
                "
                @click="selectProduct(item.itemNum, item.itemName)"
              >
                <span style="font-size: 13px">Select</span>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="text-center pt-2">
        <v-pagination
          style="padding-top: 8px"
          color="#05523E"
          v-model="page_No"
          :length="$store.state.invoice.inventoryPages"
          :total-visible="10"
          @input="movePage"
        />
      </div>
    </div>
  </v-card>
</template>
<script>
import { runGqlQuery } from "@/graphql/gqlUtil.js";
import { GETINVENTORYLENGTH } from "@/graphql/InvoiceQueries.js";

export default {
  data() {
    return {
      departmentColumn: "",
      selectedDepartment: [],
      categoryColumn: "",
      search: "",
      page_No: 1,
      headers: [
        {
          text: "Item Number",
          align: "start",
          value: "itemNum",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          text: "Item Name",
          value: "itemName",
          sort: (a, b) => a.localeCompare(b),
        },
        { text: "Vendor Name", value: "vendorName" },
        {
          text: "Department",
          value: "department",
          sort: (a, b) => a.localeCompare(b),
        },
        { text: "", value: "inTemplate", sortable: false },
      ],
      categories: [
        { name: "Category", value: "", sort: (a, b) => a.localeCompare(b) },
        {
          name: "Item Number",
          value: "ItemNum",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          name: "Item Name",
          value: "ItemName",
          sort: (a, b) => a.localeCompare(b),
        },
        {
          name: "Vendor Name",
          value: "Company",
          sort: (a, b) => a.localeCompare(b),
        },
      ],
    };
  },
  async created() {
    await this.searchInventories();
  },
  methods: {
    async getInventoriesLength() {
      try {
        const req = {
          Column: this.categoryColumn,
          Search: this.search,
          Dept_ID: this.selectedDepartment,
        };

        const inventoryPage = await runGqlQuery(GETINVENTORYLENGTH, req);

        this.$store.state.invoice.inventoryPages = Math.ceil(
          inventoryPage.getInventoriesLength.Length / 10
        );
      } catch (err) {
        console.error(err);
      }
    },
    async getInventories() {
      try {
        const req = {
          Column: this.categoryColumn,
          Search: this.search,
          Dept_ID: this.selectedDepartment,
          Page_No: this.page_No - 1,
          Page_Size: 10,
          belong: "empty",
        };
        await this.$store.dispatch("invoice/getInventoryList", req);
      } catch (err) {
        console.error(err);
      }
    },
    async searchInventories() {
      try {
        await this.getInventoriesLength();
        this.page_No = 1;
        await this.getInventories();
      } catch (err) {
        console.error(err);
      }
    },
    async searchByWord() {
      try {
        if (this.categoryColumn === "" && this.search !== "") {
          return this.$store.commit("common/snackErrOn", {
            text: "Please select a category",
          });
        }
        await this.searchInventories();
      } catch (err) {
        console.error(err);
      }
    },
    async searchByDepartment() {
      try {
        if (this.departmentColumn !== "") {
          this.selectedDepartment = [this.departmentColumn];
        } else {
          this.selectedDepartment = [];
        }
        await this.searchInventories();
      } catch (err) {
        console.error(err);
      }
    },
    async selectProduct(custNum, company) {
      try {
        await this.$emit("selectProduct", custNum, company);
        this.closeModal();
      } catch (err) {
        console.error(err);
      }
    },
    async movePage(page) {
      try {
        this.page_No = page;
        await this.getInventories();
      } catch (err) {
        console.error(err);
      }
    },
    async closeModal() {
      try {
        this.$store.commit("common/changeSearchProductModalView");
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  color: black;
}
</style>
